import { BTM_MODELS } from './btmModels';
import { LocationTag } from './locationTags';

export interface Location {
  id: string;
  name: string;
  storeName: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  coordinates: {
    lat: number;
    lng: number;
  };
  hours: {
    monday: string;
    tuesday: string;
    wednesday: string;
    thursday: string;
    friday: string;
    saturday: string;
    sunday: string;
  };
  btmFeatures: {
    type: 'Buy' | 'Sell' | 'Both';
    model: string;
    limits: {
      min: number;
      max: number;
    };
  };
  tags: LocationTag[];
}

export const locations: Location[] = [
  {
    id: "dal-001",
    name: "DiversiCoin Downtown BTM",
    storeName: "Downtown Business Center",
    address: "Contact support for exact location",
    city: "Dallas",
    state: "TX",
    zip: "75201",
    coordinates: {
      lat: 32.7867,
      lng: -96.8005
    },
    hours: {
      monday: "8:00 AM - 10:00 PM",
      tuesday: "8:00 AM - 10:00 PM",
      wednesday: "8:00 AM - 10:00 PM",
      thursday: "8:00 AM - 10:00 PM",
      friday: "8:00 AM - 11:00 PM",
      saturday: "9:00 AM - 11:00 PM",
      sunday: "10:00 AM - 8:00 PM"
    },
    btmFeatures: {
      type: "Buy and Sell Bitcoin",
      model: BTM_MODELS.MODEL_V.name,
      limits: {
        min: 20,
        max: 5000
      }
    },
    tags: ['premium', 'ada', 'security', 'indoor', 'high-volume', 'cameras', 'wifi', 'food']
  },
  {
    id: "dal-002",
    name: "Uptown Plaza BTM",
    storeName: "Uptown Shopping Center",
    address: "Contact support for exact location",
    city: "Dallas",
    state: "TX",
    zip: "75201",
    coordinates: {
      lat: 32.7933,
      lng: -96.8027
    },
    hours: {
      monday: "9:00 AM - 9:00 PM",
      tuesday: "9:00 AM - 9:00 PM",
      wednesday: "9:00 AM - 9:00 PM",
      thursday: "9:00 AM - 9:00 PM",
      friday: "9:00 AM - 10:00 PM",
      saturday: "10:00 AM - 10:00 PM",
      sunday: "11:00 AM - 7:00 PM"
    },
    btmFeatures: {
      type: "Buy Bitcoin",
      model: BTM_MODELS.MINI.name,
      limits: {
        min: 20,
        max: 2000
      }
    },
    tags: ['parking', 'cameras', 'indoor', 'food', 'atm', 'bitcoin-accepted']
  },
  {
    id: "dal-003",
    name: "Deep Ellum BTM",
    storeName: "Deep Ellum Plaza",
    address: "Contact support for exact location",
    city: "Dallas",
    state: "TX",
    zip: "75226",
    coordinates: {
      lat: 32.7834,
      lng: -96.7819
    },
    hours: {
      monday: "10:00 AM - 8:00 PM",
      tuesday: "10:00 AM - 8:00 PM",
      wednesday: "10:00 AM - 8:00 PM",
      thursday: "10:00 AM - 8:00 PM",
      friday: "10:00 AM - 11:00 PM",
      saturday: "10:00 AM - 11:00 PM",
      sunday: "12:00 PM - 6:00 PM"
    },
    btmFeatures: {
      type: "Buy and Sell Bitcoin",
      model: BTM_MODELS.UNIVERSAL.name,
      limits: {
        min: 20,
        max: 8000
      }
    },
    tags: ['high-volume', 'parking', 'well-lit', 'cameras', 'wifi', 'bitcoin-accepted']
  }
];